exports = module.exports = require("../../../../../css-loader/dist/runtime/api.js")(false);
// Imports
exports.i(require("-!../../../../../css-loader/dist/cjs.js??ref--8-1!@notes/sticky-notes-sdk/dist-es2015/styles/custom-properties.css"), "");
exports.i(require("-!../../../../../css-loader/dist/cjs.js??ref--8-1!../../styles/widths.css"), "");
// Module
exports.push([module.id, "._1b9IO2PAx6VMoej-psqAjo{position:relative;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1;min-width:412px}html[dir] ._1b9IO2PAx6VMoej-psqAjo{border-radius:3px}html[dir=ltr] ._1b9IO2PAx6VMoej-psqAjo{margin:64px 32px 96px 75px}html[dir=rtl] ._1b9IO2PAx6VMoej-psqAjo{margin:64px 75px 96px 32px}", ""]);
// Exports
exports.locals = {
	"n-noteEditViewContainer": "_1b9IO2PAx6VMoej-psqAjo"
};